export const generateTranslationKey = name => name.trim().toLowerCase().replace(/\s+/g, '');

/**
 * Convert a string to Proper Case.
 * Capitalize the first letter of each word and normalize extra spaces.
 */
export const toProperCase = input => {
    if (!input || typeof input !== 'string') return input;

    return input
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => {
            if (!word) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};
